export default "__VITE_ASSET__CjcM_XWr__"